// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1SULz","selects":"Documents_selects__1MkaA"};